export const QUESTION_MAX = 100;
export const ANSWER_MAX = 500;
export const FAQ_LIMIT = 10;
